import React, { useEffect, useState } from 'react'
import { useAdminContext } from '../../hooks/use-admin-context'
import { Select, useAppContext } from '@ftdr/blueprint-components-react'
import { MenuItem } from 'src/utils/shared-types'
import { ButtonComponent as Button } from '../custom-fdr-components'
import Message from './message'
import { emptyItem, initialManageVendor } from './initials'
import { api } from 'src/utils/api'
import Vendor from './vendor'

const ManageVendor: React.FC = () => {
  const {
    appSettings: { localizedText },
  } = useAppContext()
  const setOptions = () => {
    setSelectedAction(emptyItem)
    return initialManageVendor
  }
  const {
    isLoading,
    setIsLoading,
    selectedVendor,
    setSelectedAction,
    selectedAction,
    manageVendorMessage: { error, message },
    setManageVendorMessage,
  } = useAdminContext()

  const [optionsKey, setOptionsKey] = useState<MenuItem[]>([])
  const onSubmitHandler = async () => {
    setIsLoading(true)
    const data = await api.adminManageVendor(selectedVendor.id.toLowerCase(), selectedAction.value.toLowerCase())
    setManageVendorMessage(data)
    setIsLoading(false)
  }

  useEffect(() => {
    setOptionsKey(setOptions())
    //eslint-disable-next-line
  }, [selectedVendor.value])
  return (
    <div>
      <Vendor showButton={false} includedVendors={['WP', 'GE', 'BH']} />
      <Select
        id='action-select'
        required
        formField
        label={localizedText('ADMIN_LABEL_ACTION')}
        className='w-full sm:w-56 mb-6'
        options={optionsKey}
        selected={selectedAction}
        onSelect={(item) => {
          const option = { ...item } as MenuItem
          setSelectedAction(option)
        }}
      />
      <Button
        id='manage-vendor-submit'
        className='ml-4'
        size='medium'
        loading={isLoading}
        label={localizedText('BUTTON_SUBMIT')}
        onClick={onSubmitHandler}
        disabled={!selectedVendor.id.toLowerCase() || !selectedAction.value}
      />
      <Message id='cache' error={error} message={message} />
    </div>
  )
}
export default ManageVendor
